import React from "react";
import { Box } from "@mui/material";
import PersonAvatar from "../../PersonAvatar";
import { useTranslation } from "react-i18next";
import { role } from "shared/src/roles.mjs";
import { fullName } from "../../../../utils/formatter";
import { indexBy } from "shared/src/util.mjs";

export function AppointmentOppositeContent({ entry, selectedVersions }) {
  const { t } = useTranslation();

  const selId =
    selectedVersions[entry.group_id] ||
    (entry.versions.find((v) => v.is_latest)?.version_id ??
      entry.versions[entry.versions.length - 1]?.version_id);

  const selectedVersion =
    entry.versions.find((v) => v.version_id === selId) ||
    entry.versions[entry.versions.length - 1];

  const privateRoles = indexBy(selectedVersion?.privateRoles, (v) => v.key);

  const coordinators = privateRoles[role.Treatment_Coordinator]?.values ?? [];
  const doctors = privateRoles[role.Doctor]?.values ?? [];

  if (coordinators.length === 0 && doctors.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        mt: 1,
      }}
    >
      {coordinators.map((coord) => (
        <PersonAvatar
          key={coord.id}
          name={fullName(coord)}
          label={t("roles.Treatment_Coordinator")}
        />
      ))}
      {doctors.map((doc) => (
        <PersonAvatar
          key={doc.id}
          name={fullName(doc)}
          label={t("roles.Doctor")}
        />
      ))}
    </Box>
  );
}
